<template>
    <Head title="تایید شماره موبایل"/>
    <auth>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'ورود/عضویت', url: '/login'}, {title: 'تایید شماره موبایل'}]"/>
        </template>

        <form @submit.prevent="submit">
            <h1 class="h3 fw-bolder text-center mb-4">تایید شماره موبایل</h1>

            <div class="rounded alert-container">
                <div class="alert bg-light">
                    <div class="hstack gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.35288 15.0496L4.08306 14.8783L3.35288 15.0496ZM3.35288 8.95043L4.08306 9.12171L3.35288 8.95043ZM20.6471 8.95043L19.9169 9.12171L20.6471 8.95043ZM20.6471 15.0496L19.9169 14.8783L20.6471 15.0496ZM15.0496 20.6471L15.2208 21.3773L15.0496 20.6471ZM8.95044 20.6471L9.12171 19.9169L8.95044 20.6471ZM8.95043 3.35288L9.12171 4.08306L8.95043 3.35288ZM15.0496 3.35288L15.2208 2.6227L15.0496 3.35288ZM4.08306 14.8783C3.63898 12.9851 3.63898 11.0149 4.08306 9.12171L2.6227 8.77915C2.12577 10.8976 2.12577 13.1024 2.6227 15.2208L4.08306 14.8783ZM19.9169 9.12171C20.361 11.0149 20.361 12.9851 19.9169 14.8783L21.3773 15.2208C21.8742 13.1024 21.8742 10.8976 21.3773 8.77916L19.9169 9.12171ZM14.8783 19.9169C12.9851 20.361 11.0149 20.361 9.12171 19.9169L8.77916 21.3773C10.8976 21.8742 13.1024 21.8742 15.2208 21.3773L14.8783 19.9169ZM9.12171 4.08306C11.0149 3.63898 12.9851 3.63898 14.8783 4.08306L15.2208 2.6227C13.1024 2.12577 10.8976 2.12577 8.77916 2.6227L9.12171 4.08306ZM9.12171 19.9169C6.62161 19.3305 4.6695 17.3784 4.08306 14.8783L2.6227 15.2208C3.33924 18.2756 5.72442 20.6608 8.77916 21.3773L9.12171 19.9169ZM15.2208 21.3773C18.2756 20.6608 20.6608 18.2756 21.3773 15.2208L19.9169 14.8783C19.3305 17.3784 17.3784 19.3305 14.8783 19.9169L15.2208 21.3773ZM14.8783 4.08306C17.3784 4.6695 19.3305 6.62161 19.9169 9.12171L21.3773 8.77916C20.6608 5.72441 18.2756 3.33924 15.2208 2.6227L14.8783 4.08306ZM8.77916 2.6227C5.72441 3.33924 3.33924 5.72441 2.6227 8.77915L4.08306 9.12171C4.6695 6.6216 6.62161 4.6695 9.12171 4.08306L8.77916 2.6227Z"
                                fill="#212529"/>
                            <path
                                d="M11.25 15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5H11.25ZM12.75 11.5C12.75 11.0858 12.4142 10.75 12 10.75C11.5858 10.75 11.25 11.0858 11.25 11.5H12.75ZM12.75 15.5V11.5H11.25V15.5H12.75Z"
                                fill="#212529"/>
                            <circle cx="12" cy="9" r="0.5" stroke="#212529" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                        </svg>

                        <strong>کد تایید به شماره
                            {{ toFaNum(mobile, false) }}
                            ارسال شد
                        </strong>
                    </div>

                </div>
            </div>

            <code-input @change="(val) => form.code = val" @complete="submit" :fields="6"></code-input>

            <div v-if="form.errors.code" class="invalid-feedback d-block fw-bold mt-2">{{ form.errors.code }}</div>
            <div v-if="form.errors.captcha_token" class="invalid-feedback d-block fw-bold mt-2">{{ form.errors.captcha_token }}</div>
            <div v-if="loginForm.errors.captcha_token" class="invalid-feedback d-block fw-bold mt-2">{{ loginForm.errors.captcha_token }}</div>

            <button
                class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold w-100 fs-6 py-3 my-4">

                تایید
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.85288 8.95043C4.50437 6.17301 6.67301 4.00437 9.45043 3.35288C11.4563 2.88237 13.5437 2.88237 15.5496 3.35288C18.327 4.00437 20.4956 6.17301 21.1471 8.95044C21.6176 10.9563 21.6176 13.0437 21.1471 15.0496C20.4956 17.827 18.327 19.9956 15.5496 20.6471C13.5437 21.1176 11.4563 21.1176 9.45044 20.6471C6.67301 19.9956 4.50437 17.827 3.85288 15.0496C3.38237 13.0437 3.38237 10.9563 3.85288 8.95043Z"
                        stroke="white" stroke-width="1.5"/>
                    <path d="M16 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="white" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

            </button>

            <div class="text-center small text-dark">
                <template v-if="holdTimeCountDown">
                    {{ toFaNum(holdTimeCountDown) }} ثانیه
                </template>
                <button type="button" @click.prevent="resendCode" class="btn btn-link link-primary fw-bold small"
                      :disabled="holdTimeCountDown > 0">
                    دریافت مجدد کد تایید
                </button>
            </div>
        </form>
    </auth>
</template>

<script>
import {useForm, Link, Head} from '@inertiajs/inertia-vue3';
import {ref} from 'vue';
import {useReCaptcha} from 'vue-recaptcha-v3';

import Auth from "../../Layouts/Auth";
import CodeInput from '../../Components/CodeInput';
import Breadcrumb from "../../Components/Breadcrumb";
import {mapActions} from "vuex";

export default {
    components: {
        Auth,
        CodeInput,
        Link,
        Breadcrumb,
        Head,
    },
    props: [
        'mobile',
        'holdTime',
        'uuid',
    ],
    setup(props) {
        const loginForm = useForm({
            mobile: props.mobile,
            captcha_token: null,
        })

        const {executeRecaptcha, recaptchaLoaded} = useReCaptcha()

        const form = useForm({
            mobile: props.mobile,
            code: null,
            captcha_token: null,
        })

        const resendCode = async () => {
            form.code = null
            // await recaptchaLoaded()
            // loginForm.captcha_token = await executeRecaptcha('sendMobileVerificationCode')
            loginForm.captcha_token = 'x'
            loginForm.post('/mobile-verification')
        }

        const holdTimeCountDown = ref(props.holdTime)

        setInterval(() => {
            holdTimeCountDown.value = holdTimeCountDown.value > 0 ? holdTimeCountDown.value - 1 : 0
        }, 1000)

        const submit = async () => {
            // await recaptchaLoaded()
            // form.captcha_token = await executeRecaptcha('login')
            form.captcha_token = 'x'
            form.post('/login', {
                onSuccess: () => {
                    this.getCartItems()
                    this.getUser()
                }
            })
        }

        return {form, holdTimeCountDown, loginForm, resendCode, submit}
    },

    watch: {
        uuid() {
            this.holdTimeCountDown = this.holdTime
        }
    },

    methods: {
        ...mapActions('cart', [
            'getCartItems',
        ]),
        ...mapActions('auth', [
            'getUser',
        ]),
    }
}
</script>

<style scoped>

</style>
